import { format, isValid, parseISO } from 'date-fns';

export const formatDateToCanonical = (date: Date): string => format(date, 'yyyy-MM-dd');

export const getTodayCanonicalDate = (): string => formatDateToCanonical(new Date());

export const getDateFromCanonical = (value: string | null | undefined): Date | null => {
  if (!value) return null;
  const parsed = parseISO(value);
  return isValid(parsed) ? parsed : null;
};

export const formatCanonicalDateForDisplay = (value: string): string => {
  const parsed = getDateFromCanonical(value);
  if (!parsed) return value;
  return format(parsed, 'MM/dd/yyyy');
};
